export default __webpack_public_path__ + "static/media/apple-watch.933e579c.jpg";